const apiErrorMappings = {
  // custodian_id: { 'value not found': 'PIC Tidak Ditemukan' },
  expired_date: {
    'value should be greater than now': 'Tanggal Kadaluwarsa harus lebih dari hari ini',
  },
  attachment: {
    'contract should have attachment': 'Dokumen pendukung wajib diisi',
  },
  rates: {
    'value not found': 'Tarif harga wajib diisi'
  }
}

export default apiErrorMappings
